import { ReactElement } from "react";
import { NavLink } from "react-router-dom";
import { navigation, NavItem } from "../../../routes";
import { className } from "../../../shared/helpers";
import styles from "./SubHeader.module.scss";

interface SubHeaderProps
{
    visible: boolean;
}

const SubHeader = (props: SubHeaderProps): ReactElement =>
{
    return (
        <nav {...className(styles.wrapper, { [styles.visible]: props.visible })}>
            <ul className={styles.list}>
                {navigation.filter(x => !x.hideOnNav).map((item: NavItem, i: number) => (
                    <li key={`link_${i}`}>
                        <NavLink to={item.path} className={styles.link} activeClassName={styles.active}>
                            <i className="material-icons">{item.icon}</i>
                            <span>{item.label}</span>
                        </NavLink>
                    </li>
                ))}
            </ul>
        </nav>
    );
}

export default SubHeader;